// 언어 설정 라이브러리
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationKO from "./ko/translation.json";
import translationEN from "./en/translation.json";
import translationJA from "./ja/translation.json";
import { getLocalStorageWithExpiry } from "./langFunc";
import getCountry from "../library/getCountry";

const resources = {
  en: {
    translation: translationEN,
  },
  ko: {
    translation: translationKO,
  },
  ja: {
    translation: translationJA,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getLocalStorageWithExpiry("i18nextLng") || getCountry(),
  fallbackLng: "en",
  debug: false,
  interpolation: { escapeValue: true },
  returnObjects: true,
  returnEmptyString: true,
  returnNull: true,
});

export default i18n;
